<template>
  <div class="content">
    <div class="top">
      <img src="../../assets/images/news.png">
      <span>暂无最新消息</span>
    </div>
    <div class='zhuti'>
      <div class="search">
        <div class="title">待推荐企业</div>
        <el-form
          ref="form"
          :model="form"
          class="formBox"
          :inline="true"
        >
          <el-form-item label="企业名称">
            <div class="input">
              <el-input
                v-model="form.company"
                clearable
                placeholder="请输入企业名称"
              ></el-input>
              <span
                class='text'
                @click="getGslist"
              ><i class="el-icon-search"></i></span>
            </div>

          </el-form-item>
          <el-form-item label="申请开始时间">
            <!-- <el-date-picker
              class="date"
              v-model="form.applyTime"
              type="monthrange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              format='yyyy年MM月'
              value-format="yyyy-MM"
              @change="handerQuery()"
            >
            </el-date-picker> -->
            <el-date-picker
              :editable="false"
              v-model="form.startTime"
              :picker-options="startDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择开始日期"
              @change='handerQuery'
            />
          </el-form-item>
          <el-form-item label="申请结束时间">
            <el-date-picker
              :editable="false"
              v-model="form.endTime"
              :picker-options="endDatePicker"
              type="month"
              value-format="yyyy-MM"
              format="yyyy-MM"
              placeholder="选择结束日期"
              @change='handerQuery'
            />
          </el-form-item>
        </el-form>

        <el-form
          ref="form"
          :model="form"
          class="formBox"
          :inline="true"
        >
          <el-form-item label="需求金额">
            <el-select
              v-model="form.demand"
              placeholder="请选择活动区域"
              clearable
              class="demand"
              @change="query()"
            >
              <el-option
                label="100万以下"
                value="1"
              ></el-option>
              <el-option
                label="100万以上"
                value="2"
              ></el-option>
              <!-- <el-option
                label="100-200万"
                value="3"
              ></el-option>
              <el-option
                label="200-500万"
                value="4"
              ></el-option>
              <el-option
                label="500万以上"
                value="5"
              ></el-option> -->
            </el-select>
          </el-form-item>
        </el-form>
      </div>
      <div class="button">
        <el-button
          type="text"
          class="btn"
          @click="(total>0)?exportList():expor()"
        ><img src="../../assets/images/export.png" /> 导出
        </el-button>
        <el-button
          type="text"
          class="btn"
          @click="showConfirm"
        ><img src="../../assets/images/recommended.png" />推荐
        </el-button>
      </div>
      <div class="companyList">
        <el-table
          :data="companyList"
          style="width: 100%;"
          max-height="560px"
        >
          <el-table-column
            prop="enterpriseName"
            label="企业名称"
            width="300"
            style="background:#F3F4F9;"
          >
          </el-table-column>
          <el-table-column
            prop="enterpriseCode"
            label="统一信用代码"
            width="260"
          >
          </el-table-column>
          <el-table-column
            width="239"
            prop="loanMaxAmount,loanMinAmount"
            label="需求金额"
          >
            <template slot-scope="scope">
              {{scope.row.loanMinAmount}}-{{scope.row.loanMaxAmount}}万
            </template>
          </el-table-column>
          <el-table-column
            prop="createTime"
            label="申请时间"
            width="240"
          >
          </el-table-column>
        </el-table>
        <el-pagination
          layout="prev, pager, next"
          :total="total"
          @size-change="handleSizeChange"
          :page-size="pagesize"
          :current-page.sync="size"
        >
        </el-pagination>

      </div>
      <el-dialog
        :visible.sync="Confirm"
        :show-close='false'
        :width="dialogWidth"
        custom-class="class1"
        title="推荐企业"
        :close-on-click-modal="false"
        :modal-append-to-body="false"
        :lock-scroll="false"
      >
        <div class="top">
          <span class="xuanze">选择银行</span>
          <el-select
            v-model="value"
            clearable
            collapse-tags
            placeholder="请选择"
            :multiple=true
            value-key="id"
            @change='handleChange'
          >
            <el-checkbox
              style="margin-left:10px;"
              v-model="checked"
              @change='selectAll'
            >全选</el-checkbox>
            <el-option
              v-for="item in options"
              :key="item.id"
              :label="item.bankName"
              :value="item"
            >
            </el-option>
          </el-select>
        </div>
        <div class="bottom">
          <div class="upload">
            <span class="upload-text">
              <span>
                请点击上传推荐企业名单
              </span>

              <el-upload
                class="upload-demo"
                :action="xslUrl"
                :headers="headers"
                :data='params'
                accept=".xlsx,.xls"
                :show-file-list='false'
                :on-success='handleAvatarSuccess'
                :on-change='handleAvatarChange'
              >
                <el-link type="primary">选择文件
                </el-link>
              </el-upload>

            </span>
            <span class="upload-btn">* 仅支持上传xls/xlsx文件</span>
          </div>
          <div class="sample"> <img
              src="@/assets/images/excel.png"
              alt=""
            />
            <div>{{FileName}}</div>
          </div>
        </div>
        <div class="btn">
          <el-button
            class="anniu"
            @click="Confirm = false"
          >取消</el-button>
          <el-button
            @click=" getRecommend"
            type="primary"
            class="anniu"
          >确认</el-button>
        </div>
      </el-dialog>
    </div>

  </div>
</template>
<script>
import { JgList, bankList, recommend, BankList } from '@/api/statistics'
import baseUrl from "@/api/baseUrl";
export default {
  data () {
    return {
      form: {
        company: '',
        applyTime: [],
        startTime: '',
        endTime: '',
        demand: '',
      },
      Confirm: false,
      size: 1,
      pageSize: 10,
      status: 1,
      appDeptCode: '',
      appDeptName: '',
      bankId: '',
      startTime: '',
      endTime: '',
      loanMinAmount: '',
      loanMaxAmount: '',
      companyList: [],
      pagenum: 1, // 当前页数
      pagesize: 10, // 每页显示条目个数
      total: 0,//总条数
      options: [],
      value: '',
      xslUrl: baseUrl + '/api/credit/import/applyLoan',
      headers: {
        token: sessionStorage.getItem('token')
      },
      params: {
        type: 6,
      },
      loanBanks: [],
      fileId: '',
      dialogWidth: "570px",
      FileName: '',
      startDatePicker: this.beginDate(),
      endDatePicker: this.processDate(),
      checked: false,
    }
  },
  created () {
    this.getBankList()
    this.getGslist()
  },
  mounted () {
    window.onresize = () => {
      return (() => {
        this.setDialogWidth()
      })()
    }
  },
  methods: {
    beginDate () {
      const self = this;
      return {
        disabledDate (time) {
          if (self.form.endTime) {
            //如果结束时间不为空，则小于结束时间
            return new Date(self.form.endTime).getTime() < time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      };
    },
    processDate () {
      const self = this;
      return {
        disabledDate (time) {
          if (self.form.startTime) {
            //如果开始时间不为空，则结束时间大于开始时间
            return new Date(self.form.startTime).getTime() > time.getTime();
          } else {
            // return time.getTime() > Date.now()//开始时间不选时，结束时间最大值小于等于当天
          }
        }
      }
    },
    setDialogWidth () {
      var val = document.body.clientWidth
      const def = 570 // 默认宽度
      if (val < def) {
        this.dialogWidth = '100%'
      } else {
        this.dialogWidth = def + 'px'
      }
    },
    getGslist () {
      const params = {
        appDeptName: this.form.company,
        startTime: this.startTime,
        endTime: this.endTime,
        loanMinAmount: this.loanMinAmount,
        loanMaxAmount: this.loanMaxAmount,
        status: this.status,
        page: this.size,
        pageSize: this.pageSize
      };
      JgList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code === 200) { // 请求成功后赋值
          this.companyList = res.data
          this.total = res.data.length
        }
      }).catch(error => { })
    },
    showConfirm () {
      if (this.total == 0) {
        this.Confirm = false
        this.$message.error('推荐列表为空')
      } else {
        this.Confirm = true
      }
    },
    handerQuery () {
      if (this.form.startTime == null) {
        this.form.startTime = ''
      }
      if (this.form.endTime == null) {
        this.form.endTime = ''
      }
      this.startTime = this.form.startTime
      this.endTime = this.form.endTime
      // if (this.form.applyTime == null) {
      //   this.form.applyTime = []
      //   this.startTime = ''
      //   this.endTime = ''
      // } else {
      //   this.startTime = this.form.applyTime[0]
      //   this.endTime = this.form.applyTime[1]
      this.getGslist()
      // }
    },
    query () {
      if (this.form.demand == null) {
        this.form.demand = ''
      } else {
        switch (this.form.demand) {
          case '1':
            this.loanMinAmount = 0;
            this.loanMaxAmount = 100;
            break;
          case '2':
            this.loanMinAmount = 100;
            this.loanMaxAmount = '';
            break;
          // case '3':
          //   this.loanMinAmount = 100;
          //   this.loanMaxAmount = 200;
          //   break;
          // case '4':
          //   this.loanMinAmount = 200;
          //   this.loanMaxAmount = 500;
          //   break;
          // case '5':
          //   this.loanMinAmount = 500;
          //   this.loanMaxAmount = undefined;
          //   break;
          default:
            this.loanMinAmount = undefined;
            this.loanMaxAmount = undefined;

        }
        this.getGslist()
      }
    }, expor () {
      this.$message.error('导出列表为空')
    },
    exportList () {
      const xhr = new XMLHttpRequest();
      xhr.open("post", this.baseUrl + "/api/credit/excel/expertChooseCreditExcel", true);  // get、post都可
      xhr.responseType = "blob";  // 转换流
      xhr.setRequestHeader("token", sessionStorage.getItem("token")); // token键值对
      xhr.setRequestHeader("Content-Type", "application/x-www-form-urlencoded")
      xhr.onload = function () {
        if (this.status === 200) {
          const blob = this.response;
          const fileName = "信易贷待推荐企业列表.xls";
          if (window.navigator.msSaveOrOpenBlob) {
            navigator.msSaveBlob(blob, fileName);
          } else {
            const a = document.createElement("a")
            const url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click()
            window.URL.revokeObjectURL(url)
          }
        }
      }
      xhr.send("appDeptName=" + this.form.company + "&startTime=" + this.startTime + '&endTime=' + this.endTime + "&loanMinAmount=" + this.loanMinAmount + "&loanMaxAmount=" + this.loanMaxAmount + "&status=" + this.status);
    },
    handleSizeChange (val) {
      this.pagesize = val;
    },
    handleAvatarChange (res) {
      this.FileName = res.name
    },
    handleAvatarSuccess (res) {
      if (res.code == 200) {
        this.fileId = res.data.id
        this.$message.success('文件上传' + res.msg);
      } else {
        this.$message.error(res.msg)
      }
    },
    //获取推荐银行列表
    getBankList () {
      const params = {
        isUsed: 1
      }
      BankList(this.sendParam(params)).then(res => {
        res = this.paramDecrypt(res);
        if (res.code == 200) {
          this.options = res.data;
        }
      }).catch(err => { })
    },
    handleChange (val) {
      if (val.length == this.options.length) {
        this.checked = true
      } else {
        this.checked = false
      }
      let list = val
      let listarry = []
      list.forEach((iteam) => {
        let arr = {}
        arr.bankId = iteam.bankId
        arr.bankName = iteam.bankName
        listarry.push(arr)
        return listarry
      })
      this.loanBanks = listarry
    },
    selectAll () {
      this.selectedArray = []

      if (this.checked) {
        this.options.map((item) => {
          let arr = {}
          arr.bankId = item.bankId
          arr.bankName = item.bankName
          this.loanBanks.push(arr)
        })
        this.value = this.options
      } else {
        this.loanBanks = []
        this.value = ''
      }
    },
    getRecommend () {
      if (this.fileId != '') {
        const params = {
          loanBanks: this.loanBanks,
          fileId: this.fileId
        }
        recommend(this.sendParam(params)).then(res => {
          res = this.paramDecrypt(res);
          if (res.code == 200) {
            this.$message.success(res.msg)
            this.Confirm = false
            this.fileId = ''
            this.getGslist()
          }
          else if (res.code == 202) {
            this.$message.error(res.msg)
          }
        }).catch(err => { })
      } else {
        this.$message.error('请先上传推荐企业名单')
      }

    }

  }
}
</script>
<style lang='less' scoped>
.content {
  width: 100%;
  height: 848px;
  border-radius: 8px;
  .top {
    font-size: 14px;
    font-family: Alibaba PuHuiTi;
    font-weight: 400;
    color: #2a2a2a;
    line-height: 40px;
    height: 40px;
    background-color: #fff;
    padding-left: 10px;
    img {
      margin-right: 10px;
      margin-top: 5px;
    }
  }
  .zhuti {
    background-color: #fff;
    margin-top: 24px;
    border-radius: 5px;
    .search {
      padding-top: 15px;
      .title {
        height: 24px;
        font-size: 24px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2981ee;
        line-height: 24px;
        border-left: 6px solid #2981ee;
        padding-left: 20px;
      }
      .formBox {
        margin-top: 25px;
        padding: 0 20px 0 40px;
        display: flex;
        justify-content: space-between;
        .input {
          color: #2981ee;
          display: flex;
          align-items: center;
          border: 1px solid #dde0e7;
          border-radius: 5px;
          /deep/ .el-input__inner {
            border: none;
          }
          .text {
            margin-right: 5px;
            margin-left: 5px;
            border-left: 1px solid #dde0e7;
            width: 30px;
            height: 25px;
            display: flex;
            text-align: center;
            justify-content: center;
            align-items: center;
          }
        }
        /deep/ .el-form-item__content {
          width: 200px;
        }
        /deep/ .el-form-item {
          display: flex;
        }
        .demand {
          width: 128px !important;
        }
        .date {
          width: 240px !important;
        }
      }
    }
    .button {
      height: 45px;
      width: 100%;
      display: flex;
      justify-content: flex-start;
      margin: 20px 0 20px 37px;
      padding-right: 20px;
      .btn {
        margin-right: 20px;
        width: 110px;
        height: 100%;
        background: #2981ee;
        color: #fff;
        display: flex;
        align-items: center;
        justify-content: center;
        text-align: center;
        font-size: 16px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        border-radius: 8px;
        img {
          vertical-align: text-top;
          margin-right: 3px;
        }
      }
    }
    .companyList {
      height: 600px;
      width: 100%;
      background-color: #fff;
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      position: relative;
      /deep/ .el-table th {
        background: #f3f4f9;
        text-align: center;
      }
      /deep/ .el-table td {
        text-align: center;
      }
    }
    /deep/ .el-pagination {
      height: 30px;
      position: absolute;
      bottom: 20px;
      left: 50%;
      transform: translate(-50%);
    }
  }
}
</style> 
<style lang='less'>
.class1 {
  border-radius: 6px !important;
  padding: 0 !important;
  background-color: #f1f1f1;
  .el-dialog__header {
    text-align: center;
    font-size: 26px;
    font-family: Alibaba PuHuiTi;
    font-weight: 500;
    color: #000000;
  }
  .top {
    background-color: #f1f1f1f1 !important;
    display: flex;
    justify-content: center;
    box-sizing: border-box;
    .xuanze {
      margin-top: 10px;
    }
    .el-select {
      width: 300px;
      margin-left: 20px;
      height: 120px;
      position: relative;
    }
    .el-select__tags {
      flex-wrap: unset;
      overflow: auto;
      position: absolute;
      top: 28px;
      left: 5px;
    }
    .el-input__inner {
      height: 60px !important;
      width: 320px !important;
    }
  }
  .bottom {
    width: 100%;
    height: 196px;
    margin-top: 40px;
    background-color: #fff;
    border: 1px dashed #d4d4d7;
    padding: 30px;
    box-sizing: border-box;
    .upload {
      height: 80px;
      width: 100%;
      border-bottom: 1px solid#DEDEE0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      align-items: center;
      padding: 10px;
      box-sizing: border-box;
      .upload-text {
        font-size: 20px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #2a2a2a;
        margin-right: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
      }
      .upload-btn {
        font-size: 18px;
        font-family: Alibaba PuHuiTi;
        font-weight: 500;
        color: #a2a4ac;
      }
    }
    .sample {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 25px;
      color: #a9acb7;
    }
  }
  .btn {
    width: 100%;
    height: 44px;
    margin-top: 20px;
    display: flex;
    justify-content: space-between;
    box-sizing: border-box;
    padding: 0 100px;
    .anniu {
      width: 144px;
      height: 100%;
    }
  }
}
</style>